import {
  Component,
  OnInit,
  SimpleChanges,
  Input,
  OnChanges,
  HostListener,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';
import * as _ from 'lodash';

import { MixpanelService } from 'src/app/core/services/mixpanel.service';

export type FilterOption = {
  title: string;
  options: { val: string; checked: boolean }[];
  inputType: string; //'checkbox' or 'radio'
};

@Component({
    selector: 'advanced-filters',
    templateUrl: './advanced-filters.component.html',
    styleUrls: ['./advanced-filters.component.scss'],
    standalone: false
})
export class AdvanceFiltersComponent implements OnInit, OnChanges {
  @Input() useRefreshedUi : boolean = false;
  @Input() advancedFilterData: { [key: string]: string }[] | null = null;
  @Input() pageScope: string = '';
  @Input() excludeKeys: string[] = [];
  @Input() keyInputTypes : { [title: string]: string } = {}; //optional
  @Input() selectedAdvancedFilters:{ [id: string]: string[] } = {};
  @Input() filterGroupings:{ [id: string]: string[] } = {};
  @Output() selectedFilters: EventEmitter<{ [id: string]: string[] }> = new EventEmitter<{ [id: string]: string[] }>();

  filterOptions: FilterOption[] = [];

  showAllSelectedFiltersModal: boolean = false;
  showSelectedFiltersInModal: { [id: string]: boolean } = {};
  showClearAllConfirmModal: boolean = false;

  showAllFilters: boolean = false;
  @Input() toggleBody: boolean = false;
  @Output() toggleBodyChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  toggleFooter: boolean = false;
  selectedFilterOptions: { [id: string]: string[] } = {};

  /**The maximum number of selected filter options to be displayed on the page */
  selectedFilterDisplayLimit : number = 3;

  finalSelectedFilterOptions: { [id: string]: string[] } = {};
  filterGroups: { title: string; filters: FilterOption[] }[] = [];
  constructor(private elementRef: ElementRef, private mixpanelService: MixpanelService) {}

  ngOnInit(): void {
    if (this.advancedFilterData != undefined || this.advancedFilterData != null) {
      this.setAdvancedFilters(this.advancedFilterData);
      if (this.selectedAdvancedFilters != undefined) {
        this.selectedFilterOptions = _.cloneDeep(this.selectedAdvancedFilters);
        this.showSelectedFiltersInModal = Object.keys(this.selectedFilterOptions).reduce((acc, key) => {
          acc[key] = false;
          return acc;
        }, {} as { [id: string]: boolean });
      }
    }
    if(this.useRefreshedUi){
      this.selectedFilterDisplayLimit = 3;
    }
  }

  initializeSelectedFilterOptions() {
    this.filterOptions.forEach((filter) => {
      this.selectedFilterOptions[filter.title] = [];
    });
  }

  setAdvancedFilters(data: { [key: string]: string }[] | null, excludeTitle: string | null = null) {
    if (data!.length > 0) {
      let tempFilters: { title: string, options: { val: string; checked: boolean }[], inputType:string}[] = [];
      
      let titles = Object.keys(data![0]).filter((key: string) => !this.excludeKeys.includes(key));

      titles.forEach((title:string) => {

        if(excludeTitle != null && excludeTitle == title) {
          // The options need not be filtered
          tempFilters.push(this.filterOptions.filter(x => x.title == title)[0])
        }
        else {
          //exclude 'falsy' values, like empty strings and nulls
          const uniqueValues = [...new Set(data!.map((filter) => filter[title]))].filter(Boolean);

          const options = uniqueValues.map((val) => ({
            val,
            checked: this.isValueInFilters(title, val),
          }));

          if (this.flattenFilterOptions().length > 1) {
            this.selectedFilterOptions[title] = this.selectedFilterOptions[title].filter(option => options.some(o => o.val === option));
          }        

          tempFilters.push({ title: title, options: options, inputType: this.keyInputTypes[title] || 'checkbox' });
        }
      });
  
      this.filterOptions = tempFilters;
      this.updateFilterGroups();
    }
  }

  updateFilterGroups() {
    this.filterGroups = Object.keys(this.filterGroupings).map(title => ({
      title: title,
      filters: this.filterOptions.filter(filter => this.filterGroupings[title].includes(filter.title))
    }));
}

  isValueInFilters(title: string, value: string): boolean {
    if (this.selectedFilterOptions && this.selectedFilterOptions[title] && this.selectedFilterOptions[title].includes(value)) {
      return true;
    }
    return false;
  }  

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedAdvancedFilters'] && !changes['selectedAdvancedFilters'].firstChange) {
      this.selectedFilterOptions = _.cloneDeep(this.selectedAdvancedFilters);
      this.setAdvancedFilters(this.advancedFilterData);
    }
  }

  flattenFilterOptions() {
    return Object.values(this.selectedFilterOptions).flat();
  }

  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  getVal() {
    if (this.selectedFilterOptions) {
      if (!this.showAllFilters) {
        return this.flattenFilterOptions().slice(0, this.selectedFilterDisplayLimit);
      } else {
        return this.flattenFilterOptions();
      }
    } else {
      return [];
    }
  }

  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  toggleShowAllFilters() {
    this.showAllFilters = !this.showAllFilters;
  }

  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  removeFilter(filterToRemove: string) {
    Object.keys(this.selectedFilterOptions).forEach((k, v) => {
      this.selectedFilterOptions[k] = this.selectedFilterOptions[k].filter(
        (item) => item !== filterToRemove
      );
    });

    this.updateSelectedOptions();
    this.toggleFooter = true;
  }

  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  clearAllSelectedFilterOptions() {
    this.initializeSelectedFilterOptions();
    this.updateSelectedOptions();
    this.toggleFooter = true;
  }

  

  onClickAdvFilterDiv() {
    this.toggleBody = !this.toggleBody
    this.toggleBodyChange.emit(this.toggleBody);
    if (this.toggleBody){
      this.mixpanelService.track(`Advanced Filters Opened for ${this.pageScope}`);
    }
  }
  
  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  applyFilters() {
    this.toggleFooter = false;
    this.toggleBody = false;
    this.toggleBodyChange.emit(this.toggleBody);
    this.updateSelectedOptions();this.mixpanelService.track(`Applied Advanced Filters for ${this.pageScope}`, { ...this.selectedFilterOptions });
    this.selectedFilters.emit(JSON.parse(JSON.stringify(this.selectedFilterOptions)));
  }

  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  resetFilters() {
    this.toggleFooter = false;
    let isEmpty = (values:string[][]) => {
      return values.every((v: string[]) => v.length === 0);
    }

    if (isEmpty(Object.values(this.selectedAdvancedFilters)))
      this.initializeSelectedFilterOptions();
    else {
      for (const key in this.selectedAdvancedFilters) {
        if (this.selectedFilterOptions.hasOwnProperty(key)) {
          this.selectedFilterOptions[key] = [...this.selectedAdvancedFilters[key]];
        }
      }
    }
    

    this.updateSelectedOptions();
  }

  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  updateSelectedOptions(title:string|null = null) {
    if (this.flattenFilterOptions().length > 0) {
      var data:{ [key: string]: string }[]|null = this.advancedFilterData;
      data = data && data.filter(item => {
        let pass = true;
        for (let key in this.selectedFilterOptions) {
          if (this.selectedFilterOptions[key].length > 0 && !this.selectedFilterOptions[key].includes(item[key])) {
            pass = false;
          }
        }
        return pass;
      });

      if(title != null && this.selectedFilterOptions[title].length > 0) {
        this.setAdvancedFilters(data, title);
      }
      else {
        this.setAdvancedFilters(data);
      }
    }
    else {
      this.setAdvancedFilters(this.advancedFilterData);
    }    
  }
    

  /**Deprecated, remove after EnableAdvancedFiltersUiRefresh is enabled in production */
  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if(!this.useRefreshedUi){
      if (!this.elementRef.nativeElement.contains(event.target)) {
        this.resetFilters();
        this.toggleBody = false;
        this.toggleBodyChange.emit(this.toggleBody);
      }
    }
    
  }

}
